import Image from "next/image";

export const NoData = () => {
    return (
        <div className="flex justify-center items-center h-full dark:bg-blue-cole-dark-surface">
            <div className="rounded-lg p-8">
                <div className="flex justify-center">
                    <div>
                        <Image
                            src="/img/nodata.jpg"
                            alt="NoData - Albert Einstein"
                            width={600}
                            height={600}
                            className="rounded-full"
                        />
                    </div>
                </div>
                <p className="text-lg font-semibold text-gray-800 dark:text-white text-center mt-4">
                    No hay datos disponibles.
                </p>
                <p className="text-center mt-2 text-gray-600 dark:text-white">
                    Aún no existen datos para mostrar en la tabla, por favor agregue nuevos datos con el botón AGREGAR.
                </p>
            </div>
        </div>
    );
};